import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAnchor, MatButton, MatIconAnchor, MatIconButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NavActionButton } from '../navigation.interface';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-nav-action-button',
  imports: [
    CommonModule,
    MatAnchor,
    MatButton,
    MatIconAnchor,
    MatIconButton,
    TranslateModule,
    MatIcon,
    MatTooltip,
    RouterLink,
  ],
  templateUrl: './action-button.component.html',
  styleUrl: './action-button.component.scss',
})
export class ActionButtonComponent {
  config = input.required<NavActionButton>();
}
